module.exports = __webpack_public_path__ + "img/desk2.b035bf14.png";